jQuery(document).ready(function ($) {
  $("#paired-product-select").select2({
    templateResult: formatOption,
    templateSelection: formatOption,
    width: "100%",
  });

  function formatOption(state) {
    if (!state.id) return state.text;
    var img = $(state.element).data("image");
    return $(
      '<span><img src="' + img + '">' +
        state.text +
        "</span>"
    );
  }

  jQuery('[action="/cart/add"] [type="submit"]').on("click", function () {
    var pairedId = jQuery("#paired-product-select").val();
    var pairedTitle = jQuery("#paired-product-select option:selected").attr("data-title");
    var mainTitle = jQuery("#paired-product-select").attr("data-product-title");

    if (pairedId) {
      jQuery("#paired-product-hidden-inputs").html(`<input type="hidden" name="items[1][id]" value="${pairedId}">
        <input type="hidden" name="items[1][quantity]" value="1">
        <input type="hidden" name="properties[Paired Product]" value="${pairedTitle}">
        <input type="hidden" name="items[1][properties][Paired with]" value="${mainTitle}">`);
    }else{
      jQuery("#paired-product-hidden-inputs").html('');
    }
  });
});
